import { useContext } from 'react';
import { CloseToastContext, ShowToastContext } from '../provider/context';

export const useToast = () => useContext(ShowToastContext);
export const useCloseToast = () => useContext(CloseToastContext);
